/**
 * @deprecated Use `@/features/settings/api/settings.api` instead.
 * Backward-compatible wrappers that extract userId from in-memory JWT.
 */

import { getAccessToken } from "@/shared/lib/auth-fetch"
import * as SettingsApi from "../api/settings.api"
import type { TwoFactAuthFormType } from "../schemas/two-fact-auth-form.schema"
import type { NotificationSettingsFormType } from "../schemas/setting-notifications-form.schema"
import type { SettingVerifyCodeFormType } from "../schemas/setting-verify-code-form.schema"

export { SETTINGS_QUERY_KEYS } from "../api/settings.api"

function getUserIdFromToken(): number {
  const token = getAccessToken()
  if (!token) throw new Error("No session found")
  try {
    const payload = JSON.parse(atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")))
    return parseInt(payload.sub)
  } catch {
    throw new Error("No session found")
  }
}

export async function setupTwoFactAuth(data: TwoFactAuthFormType) {
  return SettingsApi.setupTwoFactAuth(getUserIdFromToken(), data)
}

export async function getSettings() {
  return SettingsApi.getSettings(getUserIdFromToken())
}

export async function updateNotifications(data: NotificationSettingsFormType) {
  return SettingsApi.updateNotifications(getUserIdFromToken(), data)
}

export async function verifyTwoFactAuthCode(data: SettingVerifyCodeFormType) {
  return SettingsApi.verifyTwoFactAuthCode(getUserIdFromToken(), data)
}